export default __webpack_public_path__ + "07b3979998917e9d9c5dbe859244d4f8.jpeg";